
import './surveys.css';

import angular from 'angular';
import uirouter from 'angular-ui-router';

import user from '../../service/user';
import survey from '../../service/survey';

import menuLayout from '../../directive/menu-layout';
import customTable from '../../directive/custom-table';

import routing from './surveys.routes';
import SurveysController from './surveys.controller';

export default angular.module('page.surveys', [
		uirouter,
		menuLayout,
		survey,
		user,
		customTable
	])
	.config(routing)
	.controller('SurveysController', SurveysController)
	.name;



// WEBPACK FOOTER //
// ./src/page/surveys/index.js